/**
 * Load anything globally required across the theme.
 */
import "@sections/cart";
import "@sections/main-cart";
import "@sections/minicart";
import "@sections/recently-viewed";
import "@sections/collection";
import "@sections/product-notify-me";

// Global web components
import "@theme/carousel";
import "@theme/collection-carousel";
import "@theme/quantity-selector";
import "@theme/accordion";
import "@theme/modal";
import "@theme/drawer";
import "@snippets/free-shipping-indicator";
import "@snippets/cart-item";
import "@snippets/cart-upsell";

// eslint-disable-next-line no-console
console.log(
  `%cCopyright © UWP - Framework Four %c| %c${new Date().getFullYear()}`,
  "color: #0F9D58; font-weight: bold;",
  "color: #4285F4;",
  "color: #DB4437; font-style: italic;",
);
